import { TO_action_YOU_HAVE_TO_BE_loggedIn, TO_BE_LOGGED_IN } from 'mk/autogenerated/translations/auth.adbacd40aecc2c6a4a0853bd2a2e3c12'
import { isAnonymous } from 'mk/bazaar/common/userUtils';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import { getLastKnownUsernameCookie } from 'mk2/apps/users/utils';
import Interpolate from 'mk2/components/Interpolate';
import { AB_FETCH_API_FAILURE, AB_FETCH_API_SUCCESS, abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { showWarningToast } from 'mk2/helpers/toasts';
import { makeAbsoluteUrl, url } from 'mk2/helpers/urls';
import { getRequestUser } from 'mk2/reducers';
import { isSuccess } from 'mk2/reducers/loadingState';
import { getRoutingLocation } from 'mk2/selectors';
import { redirectInPWASaga } from 'mk2/services/browserHistory';
import React from 'react';
import { delay, put, race, select, take } from 'redux-saga/effects';

enum HOOK_VARIANT {
    TOAST = 'toast',
    REDIRECT = 'redirect',
}
export function* checkIfUserIsLoggedIn(action: string, next?: string) {
    const requestUser = yield select(getRequestUser);
    if (isAnonymous(requestUser)) {

        let nonauthSignupHookVariant: (HOOK_VARIANT | string) = HOOK_VARIANT.TOAST;

        const forumPostDetailSignupHooksState: ABState = yield select(getABVariant, 'nonauth_signup_hook');
        if (!isSuccess(forumPostDetailSignupHooksState.loadingState)) {
            yield put(abFetch('nonauth_signup_hook'));

            let shouldWait = true;
            while (shouldWait) {
                const { targetActionSuccess, targetActionFailure, timeout } = yield race({
                    targetActionSuccess: take(AB_FETCH_API_SUCCESS),
                    targetActionFailure: take(AB_FETCH_API_FAILURE),
                    timeout: delay(300),
                });
                if (targetActionSuccess) {
                    nonauthSignupHookVariant = targetActionSuccess.response.nonauth_signup_hook;
                    shouldWait = false;
                }
                if (targetActionFailure) {
                    shouldWait = false;
                }
            }
        } else {
            nonauthSignupHookVariant = forumPostDetailSignupHooksState.variant;
        }

        const location = yield select(getRoutingLocation);
        const lastKnownUsername = getLastKnownUsernameCookie();
        const redirectUrl = url(lastKnownUsername ? loginUrl : signupUrl, {},  {next: next || `${location.pathname}${location.search}`});
        if (nonauthSignupHookVariant === HOOK_VARIANT.REDIRECT) {
            yield redirectInPWASaga(makeAbsoluteUrl(redirectUrl));
        } else {

            yield showWarningToast(
                <Interpolate
                    i18nKey={TO_action_YOU_HAVE_TO_BE_loggedIn}
                    action={action}
                    loggedIn={<a href={redirectUrl}>{TO_BE_LOGGED_IN}</a>}
                />,
            );
        }

        return false;
    }
    return true;
}
